var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tinymce-editor"},[_c('editor',{attrs:{"init":_vm.init,"disabled":_vm.disabled},on:{"onClick":_vm.onClick},model:{value:(_vm.editorValue),callback:function ($$v) {_vm.editorValue=$$v},expression:"editorValue"}}),_c('upload-image',{attrs:{"isEditor":"","folder":"other"},on:{"postImage":_vm.postImage}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }